import { SvgIconProps } from './icon-props';

export default function CheckmarkSimple({ height = 11, width = 11 }: SvgIconProps) {
	return (
		<svg viewBox="0 0 11 11" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
			<path d="M0 5v2l4 4 7-9V0L4 9z" />
		</svg>
	);
}
